import Nav from "./nav"
import Search from "./search"
import Fancybox from "./fancybox"

document.addEventListener("DOMContentLoaded", function () {
    Nav(jQuery)
    Search(jQuery)
    Fancybox(jQuery)
})
